module.exports = __webpack_public_path__ + "static/media/four.05be5cdf.jpg";